/**
 * Favicon Utility Functions
 * Dynamically updates the browser tab favicon based on the organization's
 * favicon returned by the verifyOrganization API.
 */

// Default favicon shipped in the public folder, used when the organization
// does not provide its own favicon.
const DEFAULT_FAVICON = `${process.env.PUBLIC_URL || ""}/favicon.ico`;

export const normalizeMediaUrl = (mediaUrl) => {
  if (!mediaUrl || !String(mediaUrl).trim()) {
    return "";
  }

  const value = String(mediaUrl).trim();

  // Split off protocol so we don't collapse the "//" in "https://"
  const protocolMatch = value.match(/^(https?:\/\/)(.*)$/i);
  const protocol = protocolMatch ? protocolMatch[1] : "";
  let rest = protocolMatch ? protocolMatch[2] : value;

  // Collapse any run of multiple slashes into a single slash
  rest = rest.replace(/\/{2,}/g, "/");

  // Collapse back-to-back duplicated "org/<id>/" segments
  // e.g. "org/1/org/1/" -> "org/1/"
  rest = rest.replace(/(org\/\d+\/)\1+/gi, "$1");

  return protocol + rest;
};

export const normalizeFaviconUrl = (faviconUrl) => normalizeMediaUrl(faviconUrl);

export const setFavicon = (faviconUrl) => {
  const href = normalizeFaviconUrl(faviconUrl) || DEFAULT_FAVICON;
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = href;
};
